<script setup lang="ts">
import FullPageLoaderUIComponent from "./lib/FullPageLoaderUIComponent/FullPageLoaderUIComponent.vue";
import { useFullPageLoader } from "./lib/UseFullPageLoader";

const { showLoading } = useFullPageLoader();
</script>

<template>
  <FullPageLoaderUIComponent v-if="showLoading" :show-loading="showLoading" />
</template>

<style scoped></style>
